<template>
  <div>
      <div class="e-filter-container">
      <a v-b-toggle.sidebar-right.sidebar-backdrop class="e-filter-btn"><i class="lnr lnr-funnel"></i></a>
      </div>
      <filters-component v-on:fromFilter="filter" :filterType="filterType"></filters-component>
      <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div class="e-mtavr-15">
        გადამოწმებული დანიშნულებები
      </div>
      <!-- <button class="btn btn-primary" @click="refreshToken">a</button> -->
    </h4>
    <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
        <vue-good-table
        ref="subjectTable"
        :columns="subjectTableColumns"
        :rows="subjectTableRows"
        :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [10, 15, 25, 50],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
        :search-options="{enabled: true, placeholder: 'ტრანზაქციის N (მოსაძებნად დააჭირეთ Enter-ს)', trigger: 'enter'}"
        >
        <div slot="emptystate" class="e-mtavr-17 text-center">
        ჩანაწერი ვერ მოიძებნა ...
        </div>
        </vue-good-table>
        <router-link class="btn btn-success" to="/Aml/TransactionSubjects/SubjectRequests/PossibleOptions">დეტალები</router-link>
  </div>
</template>

<script>
import FiltersComponent from '../components/filters.vue'
export default {
  name: 'subjectRequests',
  components: {
    FiltersComponent
  },
  metaInfo: {
    title: ' - დანიშნულების სქრინინგი'
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      loading: false,
      filterType: 'subjectRequests',
      subjectTableColumns: [
        {
          label: 'მოთხოვნის N',
          type: 'number',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'ინფორმაციის წყარო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'დამუშავების %',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'გადაწყვეტილება',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'გადაწყვეტილების მიზეზი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'კომენტარი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'დანიშნულების ტექსტი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'ტრანზაქციის ID',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'ტრანზაქციის დრო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'ტრანზაქციის თანხა',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'ტრანზაქციის ვალუტა',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'გამომგზავნი ბანკი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'დამუშავების დაწყების დრო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'დამშავების დასრულების დრო',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'id'
        }
      ],
      subjectTableRows: []
    }
  },
  methods: {
    filter (value) {
      console.log(value)
    }
  }
}
</script>

<style>

</style>
